import React from 'react'
import PropTypes from 'prop-types'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { Grid, TextField } from '@material-ui/core'
import { SecaoGenerica } from 'components'
import useStyles from './FormConclusaoEntrega.styles'

export const FormConclusaoEntrega = (props) => {
  const { conclusaoForm } = props
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <SecaoGenerica titulo="DADOS GERAIS DE DESTINO">
        <Grid container spacing={2}>
          <Grid className={classes.item} item md={4} sm={6} xs={12}>
            <TextField
              fullWidth
              label="Nº DA DECLARAÇÃO DE ÓBITO"
              name="declaracaoObito"
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.declaracaoObito || ''}
              multiline
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.item} item md={4} sm={6} xs={12}>
            <TextField
              fullWidth
              label="CEMITÉRIO DE DESTINO"
              name="cemiterio"
              required
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.cemiterio || ''}
              multiline
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.item} item md={4} sm={12} xs={12}>
            <TextField
              fullWidth
              label="LOCALIZAÇÃO INTERNA NO CEMITÉRIO"
              name="localizacaoInternaCemiterio"
              required
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.localizacaoInternaCemiterio || ''}
              multiline
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.item} item xs={12}>
            <TextField
              fullWidth
              label="PERTENCES"
              name="pertences"
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.pertences || ''}
              multiline
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.item} item xs={12}>
            <TextField
              fullWidth
              label="OBSERVAÇÕES"
              name="entregaObservacoes"
              minRows={3}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.entregaObservacoes || ''}
              multiline
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </SecaoGenerica>

      <SecaoGenerica titulo="DADOS DO CADÁVER">
        <Grid container spacing={2}>
          <Grid className={classes.item} item xs={12}>
            <TextField
              fullWidth
              label="ENDEREÇO"
              name="endereco"
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.endereco || ''}
              multiline
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid className={classes.item} item md={4} sm={6} xs={12}>
            <AutocompleteNative
              name="etnia"
              noOptionsText="Sem informações"
              options={['AMARELO', 'BRANCO', 'INDÍGENA', 'NEGRO', 'PARDO', 'NÃO INFORMADO']}
              value={conclusaoForm.formState.values.etnia || null}
              onChange={(event, newValue) => {
                conclusaoForm.handleChangeNewValueByNameProperty(event, newValue, 'etnia')
              }}
              getOptionLabel={(option) => option || ''}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ETNIA"
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid className={classes.item} item md={4} sm={6} xs={12}>
            <AutocompleteNative
              name="estadoCivil"
              noOptionsText="Sem informações"
              options={['SOLTEIRO', 'CASADO', 'DIVORCIADO', 'SEPARADO JUDICIALMENTE', 'VIÚVO']}
              value={conclusaoForm.formState.values.estadoCivil || null}
              onChange={(event, newValue) => {
                conclusaoForm.handleChangeNewValueByNameProperty(event, newValue, 'estadoCivil')
              }}
              getOptionLabel={(option) => option || ''}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ESTADO CIVIL"
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid className={classes.item} item md={4} sm={12} xs={12}>
            <AutocompleteNative
              name="escolaridade"
              noOptionsText="Sem informações"
              options={['ENSINO FUNDAMENTAL INCOMPLETO', 'ENSINO FUNDAMENTAL COMPLETO', 'ENSINO MÉDIO INCOMPLETO', 'ENSINO MÉDIO COMPLETO', 'ENSINO SUPERIOR INCOMPLETO', 'ENSINO SUPERIOR COMPLETO', 'NÃO ALFABETIZADO', 'NÃO INFORMADO']}
              value={conclusaoForm.formState.values.escolaridade || null}
              onChange={(event, newValue) => {
                conclusaoForm.handleChangeNewValueByNameProperty(event, newValue, 'escolaridade')
              }}
              getOptionLabel={(option) => option || ''}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ESCOLARIDADE"
                  required
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </Grid>

          <Grid className={classes.item} item md={8} sm={12} xs={12}>
            <TextField
              fullWidth
              label="PROFISSÃO"
              name="profissao"
              minRows={1}
              onChange={conclusaoForm.handleChange}
              value={conclusaoForm.formState.values.profissao || ''}
              multiline
              required
              variant="outlined"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </Grid>
      </SecaoGenerica>


    </div >
  )
}

FormConclusaoEntrega.propTypes = {
  conclusaoForm: PropTypes.object.isRequired,
}
